"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._pflipIR = void 0;
var IRApp_1 = require("../../../IR/IRNodes/IRApp.js");
var IRFunc_1 = require("../../../IR/IRNodes/IRFunc.js");
var IRHoisted_1 = require("../../../IR/IRNodes/IRHoisted.js");
var IRVar_1 = require("../../../IR/IRNodes/IRVar.js");
// identicall to `pflip` just at UPLC level to avoid using `papp`
exports._pflipIR = new IRHoisted_1.IRHoisted(new IRFunc_1.IRFunc(3, // toFlip, secondarg, fstArg
new IRApp_1.IRApp(new IRApp_1.IRApp(new IRVar_1.IRVar(2), // toFlip,
new IRVar_1.IRVar(0) // firstArg
), new IRVar_1.IRVar(1) // secondArg
)));
exports._pflipIR.hash;
